import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../store';
import { userEndpoints } from '../../services/api/endpoints/user.endpoint';
import { User } from '../../types/user';
import { logger } from '../../utils/logger';

export const useUsers = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const selectedOrganizationId = useSelector(
    (state: RootState) => state.organizationContext.selectedOrganizationId
  );

  const fetchUsers = async () => {
    if (!selectedOrganizationId) return;

    setIsLoading(true);
    setError(null);

    try {
      const data = await userEndpoints.listUsers(selectedOrganizationId);
      setUsers(data);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to fetch users';
      setError(message);
      logger.error('Error fetching users:', err);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchUsers();
  }, [selectedOrganizationId]);

  return {
    users,
    isLoading,
    error,
    selectedOrganizationId,
    refetch: fetchUsers,
  };
};
